import React from 'react';
import './App.scss';
import { AppProvider } from './providers/AppProvider';
import { BrowserRouter } from 'react-router-dom';
import { Router } from './components/Router';
import { EditorProvider } from './providers/EditorContext';

function App() {
    return (
        <AppProvider>
            <EditorProvider>
                <BrowserRouter>
                    <Router />
                </BrowserRouter>
            </EditorProvider>
        </AppProvider>
    );
}

export default App;
